/* eslint-disable */

import { jitsiLocalStorage } from '@jitsi/js-utils/jitsi-local-storage';
import React, { useState, useRef, useEffect } from 'react';
import uuid from 'uuid';

import { Dialog } from '../../../base/dialog';
import { translate } from '../../../base/i18n';
import { Icon, IconBlurBackground, IconUpload, IconCancelSelection } from '../../../base/icons';
import { connect } from '../../../base/redux';
import { Tooltip } from '../../../base/tooltip';
import { toggleBackgroundEffect, setVirtualBackground, setCustomBackground } from '../../actions.web';
import { resizeImage } from '../../functions';
import CircularProgress from '@material-ui/core/CircularProgress';
import logger from '../../logger';
import { useMediaQuery } from '@material-ui/core';

const backgroundsLimit = 22;
const images = [
    {
        tooltip: 'Beach',
        name: 'beach.jpg',
        id: 5,
        src: 'images/virtual-background/beach.jpg'
    },
    {
        tooltip: 'Beach',
        name: 'beach2.jpg',
        id: 6,
        src: 'images/virtual-background/beach2.jpg'
    },
    {
        tooltip: 'Home',
        name: 'home.jpg',
        id: 7,
        src: 'images/virtual-background/home.jpg'
    },
    {
        tooltip: 'Home',
        name: 'home2.jpg',
        id: 8,
        src: 'images/virtual-background/home2.jpg'
    },
    {
        tooltip: 'Home',
        name: 'home3.jpg',
        id: 9,
        src: 'images/virtual-background/home3.jpg'
    },
    {
        tooltip: 'Home',
        name: 'home4.jpg',
        id: 10,
        src: 'images/virtual-background/home4.jpg'
    },
    {
        tooltip: 'Home',
        name: 'home5.jpg',
        id: 11,
        src: 'images/virtual-background/home5.jpg'
    },
    {
        tooltip: 'Home Dark',
        name: 'home-dark.jpg',
        id: 12,
        src: 'images/virtual-background/home-dark.jpg'
    },
    {
        tooltip: 'Lake ',
        name: 'lake-with-trees-sides.jpg',
        id: 13,
        src: 'images/virtual-background/lake-with-trees-sides.jpg'
    },
    {
        tooltip: 'Office',
        name: 'office.jpg',
        id: 14,
        src: 'images/virtual-background/office.jpg'
    },
    {
        tooltip: 'Office',
        name: 'office2.jpg',
        id: 15,
        src: 'images/virtual-background/office2.jpg'
    },
    {
        tooltip: 'Office',
        name: 'office3.jpg',
        id: 16,
        src: 'images/virtual-background/office3.jpg'
    },
    {
        tooltip: 'Park',
        name: 'park.jpg',
        id: 17,
        src: 'images/virtual-background/park.jpg'
    },
    {
        tooltip: 'Park',
        name: 'park2.jpg',
        id: 18,
        src: 'images/virtual-background/park2.jpg'
    },
    {
        tooltip: 'Pool',
        name: 'pool.jpg',
        id: 19,
        src: 'images/virtual-background/pool.jpg'
    },
    {
        tooltip: 'Pool',
        name: 'pool2.jpg',
        id: 20,
        src: 'images/virtual-background/pool2.jpg'
    },
    {
        tooltip: 'Pool',
        name: 'pool3.jpg',
        id: 21,
        src: 'images/virtual-background/pool3.jpg'
    },
    {
        tooltip: 'Snow',
        name: 'snow.jpg',
        id: 22,
        src: 'images/virtual-background/snow.jpg'
    },
    {
        tooltip: 'Snow',
        name: 'snow2.jpg',
        id: 23,
        src: 'images/virtual-background/snow2.jpg'
    }
];

type Props = {

    /**
     * The redux {@code dispatch} function.
     */
    dispatch: Function,

    /**
     * state for image object
     */
    _customimg: any,

    /**
     * Invoked to obtain translated strings.
     */
    t: Function
};

/**
 * Renders virtual background dialog.
 *
 * @returns {ReactElement}
 */
function VirtualBackground({ dispatch, t }: Props) {
    const [ selected, setSelected ] = useState('');
    const [ imgload, setImgload ] = useState(false);
    const [loading, setLoading] = useState(false)
    const localImages = jitsiLocalStorage.getItem('virtualBackgrounds');
    const [ storedImages, setStoredImages ] = useState((localImages && JSON.parse(localImages)) || []);
    // const [ isloading ] = useState(false);
    const inputFileRef = useRef(null);
    const media = useMediaQuery(`(max-width:760px)`)

    const deleteStoredImage = image => {
        setStoredImages(storedImages.filter(item => item !== image));
    };
    /**
     * Updates stored images on local storage.
     */
    useEffect(() => {
        jitsiLocalStorage.setItem('virtualBackgrounds', JSON.stringify(storedImages));

        if (storedImages.length === backgroundsLimit) {
            deleteStoredImage(storedImages[0]);
        }
    }, [ storedImages ]);

    useEffect(() => {
        dispatch(setCustomBackground(storedImages));
    }, []);

    const enableBlur = () => {
        setSelected('blur');
        dispatch(setVirtualBackground('', false));
        dispatch(toggleBackgroundEffect(true,(load) => {
            setLoading(load)
        }));
    };

    const removeBackground = () => {
        jitsiLocalStorage.removeItem('features/virtual-background/images');
        setSelected('none');
        dispatch(setVirtualBackground('', false));
        dispatch(toggleBackgroundEffect(false,(load) => {
            setLoading(load)
        }));
    };

    const setUploadedImageBackground = async image => {
        jitsiLocalStorage.setItem('features/virtual-background/images', JSON.stringify(image));
        setSelected(image.id);
        await dispatch(setVirtualBackground(image.src, true));
        await dispatch(toggleBackgroundEffect(true,(load) => {
            setLoading(load)
        }));

    };
    const addImageBackground = image => {
        jitsiLocalStorage.setItem('features/virtual-background/images', JSON.stringify(image));
        setSelected(image.id);
        dispatch(setVirtualBackground(image.src, true));
        dispatch(toggleBackgroundEffect(true,(load) => {
            setLoading(load)
        }));
    };

    const handleBtnClick = () => {
        inputFileRef.current.click();
    };

    const uploadImage = async imageFile => {
        const reader = new FileReader();

        reader.readAsDataURL(imageFile[0]);
        reader.onload = async () => {
            const resizedImage = await resizeImage(reader.result);

            setStoredImages([
                ...storedImages,
                {
                    id: uuid.v4(),
                    src: resizedImage
                }
            ]);
            await dispatch(setCustomBackground(storedImages));
            await dispatch(setVirtualBackground(resizedImage, true));
            await dispatch(toggleBackgroundEffect(true,(load) => {
                setLoading(load)
            }));
        };
        reader.onerror = () => {
            logger.error('Failed to upload virtual image!');
        };
    };

    useEffect(() => {

        (async () => {
            const data = jitsiLocalStorage.getItem('features/virtual-background/images');
            const parser = JSON.parse(data || '{}');

            if (Object.keys(parser).length !== 0) {
                setSelected(parser.id);
                await dispatch(setVirtualBackground(parser.src, true));
                await dispatch(toggleBackgroundEffect(true,(load) => {
                    setLoading(load)
                }));
            }
        })();

    }, []);

    return (
        <Dialog
            hideCancelButton = { true }
            submitDisabled = { false }
            disableOverlay = { true }
            okKey = { loading ? <div style = {{display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%'}}>
                <CircularProgress color = { 'inherit' } size={ 20 } />
            </div>  : 'Close' }
            okDisabled = { loading }
            titleKey = {  'virtualBackground.title' }
            width = 'medium'>
            <div className = 'vb-dialog'>
                <div className = 'rows'>
                    <div className = 'col-m-3'>
                        <div className = 'embed-meeting-dialog-header3'>
                            {t('virtualBackground.switchBackgroundTitle')}
                        </div>
                        <div className = 'virtual-background-dialog'>
                            <Tooltip
                                content = { t('virtualBackground.removeBackground') }
                                position = { 'top' }>
                                <div
                                    className = { selected === 'none' ? 'none-selected' : 'virtual-background-none' }
                                    onClick = { () => removeBackground() }>
                        None
                                </div>
                            </Tooltip>
                            <Tooltip
                                content = { t('virtualBackground.enableBlur') }
                                position = { 'top' }>
                                <Icon
                                    className = { selected === 'blur' ? 'blur-selected' : '' }
                                    onClick = { () => enableBlur() }
                                    size = { 50 }
                                    src = { IconBlurBackground } />
                            </Tooltip>
                            <div className = 'p-1' >
                                <Tooltip
                                    content = { t('virtualBackground.customImg') }
                                    position = { 'top' }>
                                    <Icon
                                        className = { selected === 'blur' ? 'blur-selected' : '' }
                                        onClick = { () => handleBtnClick() }
                                        size = { 50 }
                                        src = { IconUpload } />
                                    <input
                                        accept = 'image/*'
                                        onChange = { e => uploadImage(e.target.files) }
                                        ref = { inputFileRef }
                                        style =
                                            // eslint-disable-next-line react-native/no-inline-styles
                                            {{ 'display': 'none' }}
                                        type = 'file' />
                                </Tooltip>
                            </div>
                        </div>
                        {storedImages.length !== 0 ? <>
                            <div className = 'embed-meeting-dialog-header4'>
                                {t('virtualBackground.appliedCustomImageTitle')}
                            </div>
                            </>
                            : ''}
                        <div className = 'scroll-vb1' >
                            {storedImages.map((image, index) => (
                                <div
                                    className = 'thumbnail-container'
                                    key = { index } >
                                    <Tooltip
                                        content = { image.tooltip }
                                        position = { 'top' }>
                                        <img
                                            className = { selected === image.id ? 'thumbnail-selected1' : 'thumbnail1' }
                                            onClick = { () => setUploadedImageBackground(image) }
                                            onError = { event => event.target.style.display = 'none' }
                                            src = { image.src } />
                                        <Icon
                                            className = { 'delete-image-icon' }
                                            onClick = { () => deleteStoredImage(image) }
                                            size = { 15 }
                                            src = { IconCancelSelection } />
                                    </Tooltip>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className = 'col-m-1'>
                        <div className = { media ? 'hr-line' :'vertical-row' }/>
                    </div>
                    <div className = 'col-m-8'>
                        <div className = 'embed-meeting-dialog-header3'>
                            {t('virtualBackground.virtualImagesTitle')}
                        </div>
                        <div className = 'scroll-vb'>
                            {images.map((image, index) => (
                                <div
                                    className = { imgload ? '' : 'hold-the-iframe' }
                                    key = { index }
                                    // eslint-disable-next-line react-native/no-inline-styles
                                    style = {{ 'textAlign': 'center' }}>
                                    <Tooltip
                                        content = { image.tooltip }

                                        position = { 'top' }>
                                        <img
                                            className = { selected === image.id ? 'thumbnail-selected' : 'thumbnail' }
                                            onClick = { () => addImageBackground(image) }
                                            onLoad = { () => {
                                                setImgload(true);
                                            } }
                                            onError = { event => event.target.style.display = 'none' }
                                            style = { imgload ? {} : { display: 'none' } }
                                            src = { image.src } />
                                    </Tooltip>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            </div>
        </Dialog>
    );
}


/**
 * Maps (parts of) the redux state to {@link Toolbox}'s React {@code Component}
 * props.
 *
 * @param {Object} state - The redux store/state.
 * @private
 * @returns {{}}
 */
function _mapStateToProps(state) {
    const { customimg } = state['features/virtual-background'];

    return {
        _customimg: customimg
    };
}
export default translate(connect(_mapStateToProps)(VirtualBackground));
